import { Icon } from '@rbilabs/universal-components';
import { StyleSheet, Text, View } from 'react-native';

import { t } from 'state/intl/translations';
import { primitive, spacing } from 'styles/constants';

import { useCheckoutContext } from '../hooks/use-checkout-context';

const getNativePaymentDisclaimer = (
  allowApplePay: boolean,
  allowGooglePay: boolean
): string | undefined => {
  let nativePaymentDisclaimerId;
  if (!allowApplePay && !allowGooglePay) {
    nativePaymentDisclaimerId = t('nativePaymentNotAvailable');
  } else if (allowApplePay && !allowGooglePay) {
    nativePaymentDisclaimerId = t('googlePayPaymentNotAvailable');
  } else if (!allowApplePay && allowGooglePay) {
    nativePaymentDisclaimerId = t('applePayPaymentNotAvailable');
  }
  return nativePaymentDisclaimerId;
};

interface IWarningMessage {
  message: string;
  iconFillColor?: string;
}

const WarningMessage: React.FC<React.PropsWithChildren<IWarningMessage>> = ({
  message,
  iconFillColor,
}) => (
  <>
    <View style={styles.warningMessageIcon} testID="error-icon">
      <Icon variant="error" color={iconFillColor} size="16px" aria-hidden />
    </View>
    <Text style={styles.warningMessage}>{message}</Text>
  </>
);

const Disclaimer = ({ title, message }: { title: string; message: string }) => {
  return (
    <View style={styles.disclaimerWrapper}>
      <Text style={styles.disclaimerTitle}>{title}</Text>
      <Text style={styles.disclaimerMessage}>{message}</Text>
    </View>
  );
};

export function Disclaimers() {
  const {
    paymentMethods,
    checkoutPaymentMethodId,
    canUseApplePay,
    canUseGooglePay,
  } = useCheckoutContext();

  const selectedMethod = paymentMethods.find(
    method => method.accountIdentifier === checkoutPaymentMethodId
  );

  const nativePaymentDisclaimer = getNativePaymentDisclaimer(canUseApplePay, canUseGooglePay);

  return (
    <>
      {!selectedMethod && nativePaymentDisclaimer && (
        <View style={styles.warningContainer}>
          <WarningMessage message={nativePaymentDisclaimer} />
        </View>
      )}

      <Disclaimer title={t('cancellationPolicyTitle')} message={t('cancellationPolicy')} />
    </>
  );
}

const styles = StyleSheet.create({
  disclaimerWrapper: {
    gap: spacing.$1,
  },
  disclaimerTitle: {
    color: primitive.$bbqBrown,
    fontFamily: primitive.fontFamily.$headers,
    fontSize: 15,
    fontWeight: '500',
  },
  disclaimerMessage: {
    color: primitive.$greyOne,
    fontFamily: primitive.fontFamily.$body,
    fontSize: 14,
    fontWeight: 'normal',
  },
  warningContainer: {
    paddingTop: spacing.$6,
    paddingBottom: spacing.$3,
    paddingHorizontal: 0,
    marginRight: spacing.$3,
  },
  warningMessageIcon: {
    flexDirection: 'row',
    marginTop: 0,
    marginRight: spacing.$1,
    marginBottom: 0,
    marginLeft: 0,
  },
  warningMessage: {
    margin: 0,
    fontSize: 14,
    fontFamily: primitive.fontFamily.$body,
    fontStyle: 'normal',
    textAlign: 'left',
    lineHeight: 1,
    fontWeight: 'normal',
  },
});
